module.exports = __webpack_public_path__ + "img/manajemen.774bd3a6.png";